export const environment = {
  production: true,
  base_url: 'https://autooptiq.com'
};
